module.exports = __webpack_public_path__ + "img/edge_activites_escalade.4205f57f.svg";